webpackJsonp([4],{

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLayout_vue__ = __webpack_require__(440);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b1704e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AppLayout_vue__ = __webpack_require__(448);
function injectStyle (ssrContext) {
  __webpack_require__(446)
}
var normalizeComponent = __webpack_require__(147)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48b1704e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b1704e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AppLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppHeader'
});

/***/ }),

/***/ 354:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(80);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppFooter',

  props: {
    hidePublish: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isLoading: false,
      isPublished: false,
      isMarkerSet: null,
      isObjectSet: null,
      isMarkerDimensionsSet: null,
      toolTipText: 'Marker and Object file must be added'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('Firebase', ['getARElemisPublishedSuccessfully', 'getARElemisPublishError', 'getisMarkerSet', 'getisObjectPartiallyComplete', 'getisMarkerDimensionsSet', 'getIsMarkerOnly']), {
    whenARElemisPublishedSuccessfully: function whenARElemisPublishedSuccessfully() {
      return this.getARElemisPublishedSuccessfully;
    },
    whenARElemisPublishError: function whenARElemisPublishError() {
      return this.getARElemisPublishError;
    },
    getisMarkerSetFromState: function getisMarkerSetFromState() {
      return this.getisMarkerSet;
    },
    getisObjectPartiallyCompleteFromState: function getisObjectPartiallyCompleteFromState() {
      return this.getisObjectPartiallyComplete;
    },
    getisMarkerDimensionsSetFromState: function getisMarkerDimensionsSetFromState() {
      return this.getisMarkerDimensionsSet;
    },
    publishDisabled: function publishDisabled() {
      /* eslint-disable */
      return {
        AppFooter__disabled: !this.isMarkerSet || !this.isMarkerDimensionsSet,
        AppFooter__enabled: this.isMarkerSet && this.isMarkerDimensionsSet
      };
      /* eslint-enable */
    },
    isMarkerOnly: function isMarkerOnly() {
      return this.getIsMarkerOnly;
    }
  }),
  watch: {
    whenARElemisPublishedSuccessfully: function whenARElemisPublishedSuccessfully(newVal) {
      console.log('publish success');
      // if item is published.. stop loading.
      if (newVal) {
        this.isLoading = false;
        this.isPublished = true;
        this.toolTipText = 'Click to Update';
        // reset the values of verification.
        this.resetVerifyARElem();
      }
    },
    whenARElemisPublishError: function whenARElemisPublishError(newVal) {
      this.isLoading = !newVal;
    },
    getisMarkerSetFromState: function getisMarkerSetFromState(newVal) {
      this.isMarkerSet = newVal;

      /* eslint-disable */
      if (this.isMarkerOnly) {
        if (this.isMarkerSet && this.isMarkerDimensionsSet) {
          this.toolTipText = 'Click to Publish';
        } else {
          this.toolTipText = 'Marker, and Marker Size must be added';
        }
      } else {
        if (this.isMarkerSet && this.isObjectSet && this.isMarkerDimensionsSet) {
          this.toolTipText = 'Click to Publish';
        } else {
          this.toolTipText = 'Marker,Object file and Marker Size must be added';
        }
      }
      /* eslint-enable */
    },
    getisObjectPartiallyCompleteFromState: function getisObjectPartiallyCompleteFromState(newVal) {
      this.isObjectSet = newVal;

      if (this.isMarkerSet && this.isObjectSet && this.isMarkerDimensionsSet) {
        this.toolTipText = 'Click to Publish';
      } else {
        this.toolTipText = 'Marker,Object file and Marker Size must be added';
      }
    },
    getisMarkerDimensionsSetFromState: function getisMarkerDimensionsSetFromState(newVal) {
      this.isMarkerDimensionsSet = newVal;

      if (this.isMarkerSet && this.isObjectSet && this.isMarkerDimensionsSet) {
        this.toolTipText = 'Click to Publish';
      } else {
        this.toolTipText = 'Marker,Object file and Marker Size must be added';
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('Firebase', ['setPublishClicked', 'resetAREleminEditVerif', 'refreshAREleminEdit']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('Firebase', ['getElementById', 'isNameChanged']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('Firebase', ['fetchARElementList']), {
    onPublish: function onPublish() {
      // This will make all the watchers get that they
      // need to verify if they are ready to publish the AR Element yet.
      if (this.isMarkerOnly) {
        if (this.isMarkerSet && this.isMarkerDimensionsSet) {
          this.isLoading = true;
          this.setPublishClicked();
        }
      } else if (this.isMarkerSet && this.isObjectSet && this.isMarkerDimensionsSet) {
        if (this.isNameChanged()) {
          this.refreshAREleminEdit();
        }
        this.isLoading = true;
        this.setPublishClicked();
      }
    },
    resetVerifyARElem: function resetVerifyARElem() {
      this.resetAREleminEditVerif();
      this.fetchARElementList();
      /* eslint-disable */
      setTimeout(function () {
        this.refreshAREleminEdit();
      }.bind(this), 2000);
      /* eslint-enable */
      // Vue.nextTick(() =>{
      //   this.basketAddSuccess = false;
      // });
    }
  })
});

/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__ = __webpack_require__(353);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39db3a44_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__ = __webpack_require__(388);
function injectStyle (ssrContext) {
  __webpack_require__(386)
}
var normalizeComponent = __webpack_require__(147)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39db3a44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39db3a44_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(387);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(345)("5b4b1e43", content, true, {});

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(344)(true);
// imports


// module
exports.push([module.i, ".AppHeader[data-v-39db3a44]{margin:0;height:60px;padding:21px 62px 0 24px;background-color:#fff;color:#fff;width:100%;text-align:right;border:1px solid #f6f8fd}.AppHeader__logo[data-v-39db3a44]{height:18px}@media only screen and (max-width:768px){.AppHeader[data-v-39db3a44]{margin:0;padding:21px 32px 0 0}}", "", {"version":3,"sources":["/Users/madis/Documents/mobi/_web/mars/mars-demo/src/components/AppHeader.vue"],"names":[],"mappings":"AACA,4BACE,SAAU,AACV,YAAa,AACb,yBAA0B,AAC1B,sBAA0B,AAC1B,WAAe,AACf,WAAY,AACZ,iBAAkB,AAClB,wBAA0B,CAC3B,AACD,kCACI,WAAa,CAChB,AACD,yCACA,4BACM,SAAU,AACV,qBAAuB,CAC5B,CACA","file":"AppHeader.vue","sourcesContent":["\n.AppHeader[data-v-39db3a44] {\n  margin: 0;\n  height: 60px;\n  padding: 21px 62px 0 24px;\n  background-color: #ffffff;\n  color: #ffffff;\n  width: 100%;\n  text-align: right;\n  border: solid 1px #f6f8fd;\n}\n.AppHeader__logo[data-v-39db3a44] {\n    height: 18px;\n}\n@media only screen and (max-width: 768px) {\n.AppHeader[data-v-39db3a44] {\n      margin: 0;\n      padding: 21px 32px 0 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"AppHeader"},[_c('img',{staticClass:"AppHeader__logo",attrs:{"src":__webpack_require__(354),"alt":"Mobi Lab Logo"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__ = __webpack_require__(355);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a2c5b27_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__ = __webpack_require__(392);
function injectStyle (ssrContext) {
  __webpack_require__(390)
}
var normalizeComponent = __webpack_require__(147)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a2c5b27"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a2c5b27_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(391);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(345)("a298f744", content, true, {});

/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(344)(true);
// imports


// module
exports.push([module.i, ".AppFooter[data-v-7a2c5b27]{height:60px;background-color:#ebebeb;padding:22px 62px 21px;position:absolute;bottom:0;right:0;left:0;float:left}@media only screen and (max-width:768px){.AppFooter[data-v-7a2c5b27]{height:100px;padding:0;text-align:center}}.AppFooter__publish[data-v-7a2c5b27]{width:389px;height:60px;padding-top:5px;position:absolute;left:0;bottom:0;font-size:20px;font-weight:600;letter-spacing:.6px;text-align:center;cursor:pointer}@media only screen and (max-width:1000px){.AppFooter__publish[data-v-7a2c5b27]{width:270px}}@media only screen and (max-width:768px){.AppFooter__publish[data-v-7a2c5b27]{margin-bottom:80px;width:100%}}.AppFooter__publish[data-v-7a2c5b27]:active{-webkit-box-shadow:0 5px #666;box-shadow:0 5px #666;-webkit-transform:translateY(2px);transform:translateY(2px)}.AppFooter__publish[data-v-7a2c5b27]:focus{outline:none}.AppFooter__enabled[data-v-7a2c5b27]{background-image:linear-gradient(81deg,#ff5000,#ed8a16);color:#fff}.AppFooter__enabled[data-v-7a2c5b27]:hover{background:linear-gradient(45deg,#ff5000,#ef8414 52.86%,#ffb41e)}.AppFooter__disabled[data-v-7a2c5b27]{background-color:#d8d8d8;color:#000;cursor:not-allowed}.AppFooter__text1[data-v-7a2c5b27]{height:17px;font-size:12px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:center;color:#202020;margin-left:162px}@media only screen and (max-width:1240px){.AppFooter__text1[data-v-7a2c5b27]{margin-left:25%}}@media only screen and (max-width:1000px){.AppFooter__text1[data-v-7a2c5b27]{margin:0;padding:0;position:relative}}.AppFooter__text2[data-v-7a2c5b27]{height:20px;font-size:15px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#202020;float:right}@media only screen and (max-width:768px){.AppFooter__text2[data-v-7a2c5b27]{float:none}}.AppFooter__logo[data-v-7a2c5b27]{height:18px;margin-left:15px;position:relative;margin-bottom:-2px;float:right}@media only screen and (max-width:768px){.AppFooter__logo[data-v-7a2c5b27]{float:none}}[tooltip][data-v-7a2c5b27]{display:inline-block}[tooltip][data-v-7a2c5b27]:before{content:\"\";position:absolute;top:-6px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);border-width:4px 6px 0;border-style:solid;border-color:rgba(0,0,0,.7) transparent transparent;z-index:99;opacity:0}[tooltip-position=left][data-v-7a2c5b27]:before{left:0;top:50%;margin-left:-12px;-webkit-transform:translatey(-50%) rotate(-90deg);transform:translatey(-50%) rotate(-90deg)}[tooltip-position=top][data-v-7a2c5b27]:before{left:50%}[tooltip-position=buttom][data-v-7a2c5b27]:before{top:100%;margin-top:8px;-webkit-transform:translateX(-50%) translatey(-100%) rotate(-180deg);transform:translateX(-50%) translatey(-100%) rotate(-180deg)}[tooltip-position=right][data-v-7a2c5b27]:before{left:100%;top:50%;margin-left:1px;-webkit-transform:translatey(-50%) rotate(90deg);transform:translatey(-50%) rotate(90deg)}[tooltip][data-v-7a2c5b27]:after{content:attr(tooltip);position:absolute;left:50%;top:-6px;-webkit-transform:translateX(-50%) translateY(-100%);transform:translateX(-50%) translateY(-100%);background:rgba(0,0,0,.7);text-align:center;color:#fff;padding:4px 2px;font-size:12px;min-width:80px;border-radius:5px;pointer-events:none;padding:4px;z-index:99;opacity:0;-webkit-transition:opacity 1s;transition:opacity 1s}[tooltip-position=left][data-v-7a2c5b27]:after{left:0;top:50%;margin-left:-8px;-webkit-transform:translateX(-100%) translateY(-50%);transform:translateX(-100%) translateY(-50%)}[tooltip-position=top][data-v-7a2c5b27]:after{left:50%}[tooltip-position=bottom][data-v-7a2c5b27]:after{top:100%;margin-top:8px;-webkit-transform:translateX(-50%) translateY(0);transform:translateX(-50%) translateY(0)}[tooltip-position=right][data-v-7a2c5b27]:after{left:100%;top:50%;margin-left:8px;-webkit-transform:translateX(0) translateY(-50%);transform:translateX(0) translateY(-50%)}[tooltip][data-v-7a2c5b27]:hover:after,[tooltip][data-v-7a2c5b27]:hover:before{opacity:1}", "", {"version":3,"sources":["/Users/madis/Documents/mobi/_web/mars/mars-demo/src/components/AppFooter.vue"],"names":[],"mappings":"AACA,4BAEE,YAAa,AACb,yBAA0B,AAC1B,uBAA6B,AAC7B,kBAAmB,AACnB,SAAU,AACV,QAAS,AACT,OAAQ,AACR,UAAY,CACb,AACD,yCACA,4BACM,aAAc,AACd,UAAW,AACX,iBAAmB,CACxB,CACA,AACD,qCACI,YAAa,AACb,YAAa,AACb,gBAAiB,AACjB,kBAAmB,AACnB,OAAQ,AACR,SAAU,AACV,eAAgB,AAChB,gBAAiB,AACjB,oBAAsB,AACtB,kBAAmB,AACnB,cAAgB,CACnB,AACD,0CACA,qCACQ,WAAa,CACpB,CACA,AACD,yCACA,qCACQ,mBAAoB,AACpB,UAAY,CACnB,CACA,AACD,4CACI,8BAA+B,AACvB,sBAAuB,AAC/B,kCAAmC,AAC3B,yBAA2B,CACtC,AACD,2CACI,YAAc,CACjB,AACD,qCACI,wDAA2D,AAC3D,UAAe,CAClB,AACD,2CACI,gEAA6E,CAChF,AACD,sCACI,yBAA0B,AAC1B,WAAa,AACb,kBAAoB,CACvB,AACD,mCACI,YAAa,AACb,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,oBAAqB,AACrB,mBAAoB,AACpB,sBAAuB,AACvB,kBAAmB,AACnB,cAAe,AACf,iBAAmB,CACtB,AACD,0CACA,mCACQ,eAAiB,CACxB,CACA,AACD,0CACA,mCACQ,SAAU,AACV,UAAW,AACX,iBAAmB,CAC1B,CACA,AACD,mCACI,YAAa,AACb,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,oBAAqB,AACrB,mBAAoB,AACpB,sBAAuB,AACvB,cAAe,AACf,WAAa,CAChB,AACD,yCACA,mCACQ,UAAY,CACnB,CACA,AACD,kCACI,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,mBAAoB,AACpB,WAAa,CAChB,AACD,yCACA,kCACQ,UAAY,CACnB,CACA,AACD,2BACE,oBAAsB,CACvB,AACD,kCACE,WAAY,AACZ,kBAAmB,AACnB,SAAU,AACV,SAAU,AACV,mCAAoC,AAC5B,2BAA4B,AACpC,uBAA4B,AAC5B,mBAAoB,AACpB,oDAAqE,AACrE,WAAY,AACZ,SAAW,CACZ,AACD,gDACE,OAAS,AACT,QAAS,AACT,kBAAmB,AACnB,kDAAmD,AAC3C,yCAA2C,CACpD,AACD,+CACE,QAAU,CACX,AACD,kDACE,SAAU,AACV,eAAgB,AAChB,qEAAsE,AAC9D,4DAA8D,CACvE,AACD,iDACE,UAAW,AACX,QAAS,AACT,gBAAiB,AACjB,iDAAkD,AAC1C,wCAA0C,CACnD,AACD,iCACE,sBAAuB,AACvB,kBAAmB,AACnB,SAAU,AACV,SAAU,AACV,qDAAsD,AAC9C,6CAA8C,AACtD,0BAA+B,AAC/B,kBAAmB,AACnB,WAAY,AACZ,gBAAiB,AACjB,eAAgB,AAChB,eAAgB,AAChB,kBAAmB,AACnB,oBAAqB,AACrB,YAAiB,AACjB,WAAY,AACZ,UAAW,AACX,8BAA+B,AAC/B,qBAAuB,CACxB,AACD,+CACE,OAAS,AACT,QAAS,AACT,iBAAkB,AAClB,qDAAsD,AAC9C,4CAA8C,CACvD,AACD,8CACE,QAAU,CACX,AACD,iDACE,SAAU,AACV,eAAgB,AAChB,iDAAmD,AAC3C,wCAA2C,CACpD,AACD,gDACE,UAAW,AACX,QAAS,AACT,gBAAiB,AACjB,iDAAmD,AAC3C,wCAA2C,CACpD,AACD,+EACE,SAAW,CACZ","file":"AppFooter.vue","sourcesContent":["\n.AppFooter[data-v-7a2c5b27] {\n  /*    margin: 0;*/\n  height: 60px;\n  background-color: #ebebeb;\n  padding: 22px 62px 21px 62px;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  float: left;\n}\n@media only screen and (max-width: 768px) {\n.AppFooter[data-v-7a2c5b27] {\n      height: 100px;\n      padding: 0;\n      text-align: center;\n}\n}\n.AppFooter__publish[data-v-7a2c5b27] {\n    width: 389px;\n    height: 60px;\n    padding-top: 5px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    font-size: 20px;\n    font-weight: 600;\n    letter-spacing: 0.6px;\n    text-align: center;\n    cursor: pointer;\n}\n@media only screen and (max-width: 1000px) {\n.AppFooter__publish[data-v-7a2c5b27] {\n        width: 270px;\n}\n}\n@media only screen and (max-width: 768px) {\n.AppFooter__publish[data-v-7a2c5b27] {\n        margin-bottom: 80px;\n        width: 100%;\n}\n}\n.AppFooter__publish[data-v-7a2c5b27]:active {\n    -webkit-box-shadow: 0 5px #666;\n            box-shadow: 0 5px #666;\n    -webkit-transform: translateY(2px);\n            transform: translateY(2px);\n}\n.AppFooter__publish[data-v-7a2c5b27]:focus {\n    outline: none;\n}\n.AppFooter__enabled[data-v-7a2c5b27] {\n    background-image: linear-gradient(81deg, #ff5000, #ed8a16);\n    color: #ffffff;\n}\n.AppFooter__enabled[data-v-7a2c5b27]:hover {\n    background: linear-gradient(45deg, #FF5000 0%, #EF8414 52.86%, #FFB41E 100%);\n}\n.AppFooter__disabled[data-v-7a2c5b27] {\n    background-color: #D8D8D8;\n    color: black;\n    cursor: not-allowed;\n}\n.AppFooter__text1[data-v-7a2c5b27] {\n    height: 17px;\n    font-size: 12px;\n    font-weight: 600;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    text-align: center;\n    color: #202020;\n    margin-left: 162px;\n}\n@media only screen and (max-width: 1240px) {\n.AppFooter__text1[data-v-7a2c5b27] {\n        margin-left: 25%;\n}\n}\n@media only screen and (max-width: 1000px) {\n.AppFooter__text1[data-v-7a2c5b27] {\n        margin: 0;\n        padding: 0;\n        position: relative;\n}\n}\n.AppFooter__text2[data-v-7a2c5b27] {\n    height: 20px;\n    font-size: 15px;\n    font-weight: 600;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    color: #202020;\n    float: right;\n}\n@media only screen and (max-width: 768px) {\n.AppFooter__text2[data-v-7a2c5b27] {\n        float: none;\n}\n}\n.AppFooter__logo[data-v-7a2c5b27] {\n    height: 18px;\n    margin-left: 15px;\n    position: relative;\n    margin-bottom: -2px;\n    float: right;\n}\n@media only screen and (max-width: 768px) {\n.AppFooter__logo[data-v-7a2c5b27] {\n        float: none;\n}\n}\n[tooltip][data-v-7a2c5b27] {\n  display: inline-block;\n}\n[tooltip][data-v-7a2c5b27]::before {\n  content: \"\";\n  position: absolute;\n  top: -6px;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  border-width: 4px 6px 0 6px;\n  border-style: solid;\n  border-color: rgba(0, 0, 0, 0.7) transparent transparent transparent;\n  z-index: 99;\n  opacity: 0;\n}\n[tooltip-position='left'][data-v-7a2c5b27]::before {\n  left: 0%;\n  top: 50%;\n  margin-left: -12px;\n  -webkit-transform: translatey(-50%) rotate(-90deg);\n          transform: translatey(-50%) rotate(-90deg);\n}\n[tooltip-position='top'][data-v-7a2c5b27]::before {\n  left: 50%;\n}\n[tooltip-position='buttom'][data-v-7a2c5b27]::before {\n  top: 100%;\n  margin-top: 8px;\n  -webkit-transform: translateX(-50%) translatey(-100%) rotate(-180deg);\n          transform: translateX(-50%) translatey(-100%) rotate(-180deg);\n}\n[tooltip-position='right'][data-v-7a2c5b27]::before {\n  left: 100%;\n  top: 50%;\n  margin-left: 1px;\n  -webkit-transform: translatey(-50%) rotate(90deg);\n          transform: translatey(-50%) rotate(90deg);\n}\n[tooltip][data-v-7a2c5b27]::after {\n  content: attr(tooltip);\n  position: absolute;\n  left: 50%;\n  top: -6px;\n  -webkit-transform: translateX(-50%) translateY(-100%);\n          transform: translateX(-50%) translateY(-100%);\n  background: rgba(0, 0, 0, 0.7);\n  text-align: center;\n  color: #fff;\n  padding: 4px 2px;\n  font-size: 12px;\n  min-width: 80px;\n  border-radius: 5px;\n  pointer-events: none;\n  padding: 4px 4px;\n  z-index: 99;\n  opacity: 0;\n  -webkit-transition: opacity 1s;\n  transition: opacity 1s;\n}\n[tooltip-position='left'][data-v-7a2c5b27]::after {\n  left: 0%;\n  top: 50%;\n  margin-left: -8px;\n  -webkit-transform: translateX(-100%) translateY(-50%);\n          transform: translateX(-100%) translateY(-50%);\n}\n[tooltip-position='top'][data-v-7a2c5b27]::after {\n  left: 50%;\n}\n[tooltip-position='bottom'][data-v-7a2c5b27]::after {\n  top: 100%;\n  margin-top: 8px;\n  -webkit-transform: translateX(-50%) translateY(0%);\n          transform: translateX(-50%) translateY(0%);\n}\n[tooltip-position='right'][data-v-7a2c5b27]::after {\n  left: 100%;\n  top: 50%;\n  margin-left: 8px;\n  -webkit-transform: translateX(0%) translateY(-50%);\n          transform: translateX(0%) translateY(-50%);\n}\n[tooltip][data-v-7a2c5b27]:hover::after, [tooltip][data-v-7a2c5b27]:hover::before {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"AppFooter"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[(!_vm.isLoading)?_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hidePublish),expression:"!hidePublish"}],staticClass:"AppFooter__publish",class:_vm.publishDisabled,attrs:{"disabled":!_vm.isMarkerSet || !_vm.isMarkerDimensionsSet,"tooltip":_vm.toolTipText},on:{"click":_vm.onPublish}},[_vm._v(_vm._s(!_vm.isPublished ? 'Publish' : 'Update'))]):_vm._e(),(_vm.isLoading)?_c('button',{staticClass:"button is-loading AppFooter__publish"}):_vm._e()]),_vm._m(0),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('span',{staticClass:"AppFooter__text1"},[_vm._v("© 2018, MARS. All Rights Reserved.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('span',{staticClass:"AppFooter__text2"},[_vm._v("Powered by"),_c('img',{staticClass:"AppFooter__logo",attrs:{"src":__webpack_require__(354),"alt":"Mobi Lab Logo"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppHeader__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppFooter__ = __webpack_require__(389);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppLayout',

  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__components_AppHeader__["a" /* default */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components_AppFooter__["a" /* default */]
  }
});

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(447);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(345)("46c82f79", content, true, {});

/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(344)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"AppLayout.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AppLayout"},[_c('AppHeader'),_c('router-view'),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.0c980f2e8a358bdaf3ac.js